import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { useMerchantId } from '@/hooks/useMerchantId';

/** FR-64: `/devices` is scoped by session, no merchant_id param needed. */
export function useDevices() {
  const { merchantId } = useMerchantId();
  return useQuery({
    queryKey: ['devices', merchantId],
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/devices');
      if (error) throw error;
      return data?.data ?? [];
    },
    enabled: !!merchantId,
  });
}
